import { render, staticRenderFns } from "./newsPageEvents.vue?vue&type=template&id=f9ef7208&"
import script from "./newsPageEvents.vue?vue&type=script&lang=js&"
export * from "./newsPageEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports